import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const JOB_BASE = process.env.REACT_APP_JOB_CREATE_BASE || "";

export const getOrganisationJobDetails = createAsyncThunk(
  "getOrganisationJobDetails",
  async (org_id: string) => {
    try {
      const { data } = await axios.get(
        `${GATEWAY_BASE + JOB_BASE}/api/v1/firms/orgJobDetails?org_id=${org_id}`
      );

      return data;
    } catch (error: any) {
      // Throw the entire error object to be caught in the rejected case
      throw error.response?.data.statusCode;
    }
  }
);

const getOrganisationJobDetailsSlice = createSlice({
  name: "getOrganisationJobDetails",
  initialState: {
    loading: false,
    orgJobDetails: null as any,
    error: false,
    errorData: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrganisationJobDetails.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getOrganisationJobDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.orgJobDetails = action.payload;
    });
    builder.addCase(getOrganisationJobDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorData = action.error;
    });
  },
});

export default getOrganisationJobDetailsSlice.reducer;
